import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MenuCollapse = function MenuCollapse(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "menuCollapse",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: "4",
      y: "6",
      width: "15",
      height: "12",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 6a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1Zm-7.693 1.293a1 1 0 0 1 0 1.414L8.014 11H14a1 1 0 1 1 0 2H8.014l2.293 2.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z",
        fill: color
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#menuCollapse)",
      children: /*#__PURE__*/_jsx("path", {
        fill: color,
        d: "M0 0h24v24H0z"
      })
    })]
  });
};
export default MenuCollapse;